import { useState, useEffect, useCallback } from 'react';

export default function useCooldown(initialCooldown = 0) {
  const [cooldown, setCooldown] = useState(initialCooldown);

  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [cooldown]);

  const startCooldown = useCallback(seconds => {
    setCooldown(seconds);
  }, []);

  const resetCooldown = useCallback(() => {
    setCooldown(0);
  }, []);

  return { cooldown, startCooldown, resetCooldown };
}
